<template>
  <div>
    <div class="tab-pane-inner">
      <div class="add-section">
        <base-button
          class="add"
          icon
          size="sm"
          @click="
            () => {
              openInspectionFormSectionModal();
            }
          "
        >
          <span class="btn-inner--icon">
            <i class="far fa-plus-circle"></i>
          </span>
          <span class="btn-inner--text">
            {{ $t("INSPECTION_FORMS.ADD_INSPECTION_FORM_SECTION") }}
          </span>
        </base-button>
        <div class="bend-buttons">
          <base-button icon size="sm" @click="expandAll">
            <span class="btn-inner--icon">
              <i class="fal fa-expand-arrows"></i>
            </span>
            <span class="btn-inner--text"> {{ $t("COMMON.EXPAND_ALL") }} </span>
          </base-button>
          <base-button icon size="sm" @click="collapseAll">
            <span class="btn-inner--icon">
              <i class="fa-regular fa-arrows-minimize"></i>
            </span>
            <span class="btn-inner--text">
              {{ $t("COMMON.COLLAPSE_ALL") }}
            </span>
          </base-button>
        </div>
      </div>
      <div class="section-list">
        <collapse :activeIndexes="activeItems" :activeIndex="-1">
          <collapse-item
            v-for="(section, index) in inspectionForm.inspectionFormSections"
            v-bind:key="section.id"
          >
            <div slot="title" class="collapse-header">
              <div class="collapse-header-left">
                <div class="section-image">
                  <img
                    v-if="section.icon"
                    :src="`${section.icon}`"
                    class="argon-image mb-2"
                  />
                </div>
                <div class="section-name">
                  <span class="name">
                    {{ section.name }}
                  </span>
                  <span class="max-points">
                    ({{ section.maxPoints }}
                    {{ $t("INSPECTION_FORMS.MAX_POINTS") }})
                  </span>
                  <span class="factor">
                    ({{ $t("INSPECTION_FORMS.FACTOR_ABBREV") }} :
                    {{ section.factor }} / {{ inspectionForm.totalFactor }})
                  </span>
                </div>
              </div>
              <div class="collapse-header-right">
                <base-button size="sm" v-if="loading" :disabled="loading">
                  <i class="fal fa-spinner fa-spin"></i>
                </base-button>
                <base-button
                  size="sm"
                  @click.stop="reorderSectionDown(section)"
                  :disabled="loading"
                  v-if="
                    index < inspectionForm.inspectionFormSections.length - 1 &&
                    !loading
                  "
                >
                  <i class="fal fa-long-arrow-down"></i>
                </base-button>
                <base-button
                  size="sm"
                  @click.stop="reorderSectionUp(section)"
                  :disabled="loading"
                  v-if="index > 0 && !loading"
                >
                  <i class="fal fa-long-arrow-up"></i>
                </base-button>
                <base-button
                  size="sm"
                  @click.stop="openInspectionFormSectionModal(section)"
                  :disabled="loading"
                >
                  <i class="fal fa-edit"></i>
                </base-button>
                <base-button
                  size="sm"
                  @click.stop="deleteInspectionFormSection(section)"
                  :disabled="loading"
                >
                  <i class="fal fa-trash-alt"></i>
                </base-button>
                <span class="chevron">
                  <i class="fal fa-chevron-down"></i>
                </span>
              </div>
            </div>
            <div>
              <div class="description" v-html="section.excerpt"></div>
              <div class="fields">
                <inspection-form-section-list-sub-section-list
                  :section="section"
                  :inspectionForm="inspectionForm"
                  @onChangeInspectionForm="inspectionFormFieldChanged"
                />
              </div>
            </div>
          </collapse-item>
        </collapse>
      </div>
    </div>

    <!-- Modal add slot -->
    <inspection-form-section-form
      :inspectionForm="inspectionForm"
      :inspectionFormSection="inspectionFormSection"
      :showModal="showModal"
      :loading="loading"
      :formErrors="formErrors"
      @onCloseInspectionFormSectionModal="closeInspectionFormSectionModal"
      @onAddInspectionFormSectionForm="addInspectionFormSectionForm"
      @onEditInspectionFormSectionForm="editInspectionFormSectionForm"
      @onDeleteInspectionFormSection="deleteInspectionFormSection"
    />
  </div>
</template>

<script>
import { cloneDeep } from "lodash";
import {
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Tooltip,
  Select,
  Option,
  Button,
} from "element-ui";
import swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";
import Collapse from "@/components/Collapse/Collapse";
import CollapseItem from "@/components/Collapse/CollapseItem";
import requestErrorMixin from "@/mixins/request-error-mixin";
import InspectionFormSectionForm from "./InspectionFormSectionForm.vue";
import defaultInspectionFormSection from "./defaultInspectionFormSection";
import InspectionFormSectionListSubSectionList from "../InspectionFormSection/InspectionFormSectionListSubSectionList.vue";

export default {
  name: "inspection-form-section-list",

  components: {
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [Tooltip.name]: Tooltip,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option,
    [Button.name]: Button,
    InspectionFormSectionForm,
    InspectionFormSectionListSubSectionList,
    Collapse,
    CollapseItem,
  },

  mixins: [requestErrorMixin],

  props: ["inspectionForm"],

  data() {
    return {
      activeItems: [],
      inspectionFormSection: cloneDeep(defaultInspectionFormSection),
      showModal: false,
      loading: false,
      formErrors: null,
    };
  },

  computed: {},

  methods: {
    expandAll() {
      this.activeItems = Array.from(
        { length: this.inspectionForm.inspectionFormSections.length },
        (_, index) => index
      );
    },

    collapseAll() {
      this.activeItems = [];
    },

    openInspectionFormSectionModal(inspectionFormSection = null) {
      if (inspectionFormSection) {
        this.inspectionFormSection = inspectionFormSection;
      } else {
        this.inspectionFormSection = cloneDeep(defaultInspectionFormSection);
      }
      this.showModal = true;
    },

    closeInspectionFormSectionModal() {
      this.showModal = false;
    },

    async addInspectionFormSectionForm(inspectionFormSection) {
      this.loading = true;
      try {
        const inspectionFormSectionData = cloneDeep(inspectionFormSection);
        inspectionFormSectionData.order_number =
          this.inspectionForm.inspectionFormSections.length + 1;
        inspectionFormSectionData.inspectionForm.id = this.inspectionForm.id;

        await this.$store.dispatch(
          "inspectionFormSections/add",
          inspectionFormSectionData
        );
        this.$notify({
          type: "success",
          timeout: 3000,
          message: this.$t("INSPECTION_FORMS.INSPECTION_FORM_SECTION_ADDED"),
        });
        this.inspectionFormFieldChanged();
        this.closeInspectionFormSectionModal();
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.formErrors = error.response.data.errors;
        this.loading = false;
      }
    },

    async editInspectionFormSectionForm(inspectionFormSection) {
      this.loading = true;
      try {
        const inspectionFormSectionData = cloneDeep(inspectionFormSection);

        await this.$store.dispatch(
          "inspectionFormSections/update",
          inspectionFormSectionData
        );
        this.$notify({
          type: "success",
          timeout: 3000,
          message: this.$t("INSPECTION_FORMS.INSPECTION_FORM_SECTION_UPDATED"),
        });
        this.inspectionFormFieldChanged();
        this.closeInspectionFormSectionModal();
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.formErrors = error.response.data.errors;
        this.loading = false;
      }
    },

    async reorderSectionUp(inspectionFormSection) {
      try {
        this.loading = true;
        const inspectionFormSectionData = cloneDeep(inspectionFormSection);
        const index = this.inspectionForm.inspectionFormSections.findIndex(
          (el) => el.id === inspectionFormSectionData.id
        );
        const prevSectionData = cloneDeep(
          this.inspectionForm.inspectionFormSections[index - 1]
        );
        inspectionFormSectionData.order_number = index - 1;
        prevSectionData.order_number = index;
        await this.$store.dispatch(
          "inspectionFormSections/update",
          inspectionFormSectionData
        );
        await this.$store.dispatch(
          "inspectionFormSections/update",
          prevSectionData
        );
        this.inspectionFormFieldChanged();
        this.loading = false;
      } catch (error) {
        await this.showRequestError(error);
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.loading = false;
      }
    },

    async reorderSectionDown(inspectionFormSection) {
      try {
        this.loading = true;
        const inspectionFormSectionData = cloneDeep(inspectionFormSection);
        const index = this.inspectionForm.inspectionFormSections.findIndex(
          (el) => el.id === inspectionFormSectionData.id
        );
        const nextSectionData = cloneDeep(
          this.inspectionForm.inspectionFormSections[index + 1]
        );
        inspectionFormSectionData.order_number = index + 1;
        nextSectionData.order_number = index;
        await this.$store.dispatch(
          "inspectionFormSections/update",
          inspectionFormSectionData
        );
        await this.$store.dispatch(
          "inspectionFormSections/update",
          nextSectionData
        );
        this.inspectionFormFieldChanged();
        this.loading = false;
      } catch (error) {
        await this.showRequestError(error);
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.loading = false;
      }
    },

    async deleteInspectionFormSection(inspectionFormSection) {
      this.loading = true;
      const confirmation = await swal.fire({
        title: this.$t("INSPECTION_FORMS.DELETE_THIS_INSPECTION_FORM_SECTION"),
        type: "question",
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: this.$t("COMMON.YES"),
        cancelButtonText: this.$t("COMMON.NO"),
        confirmButtonClass: "btn btn-primary",
        cancelButtonClass: "btn btn-warning",
      });

      try {
        if (confirmation.isConfirmed) {
          await this.$store.dispatch(
            "inspectionFormSections/destroy",
            inspectionFormSection.id
          );
          this.inspectionFormFieldChanged();
          this.$notify({
            type: "success",
            timeout: 3000,
            message: this.$t(
              "INSPECTION_FORMS.INSPECTION_FORM_SECTION_DELETED"
            ),
          });
          this.loading = false;
          this.showModal = false;
        }
      } catch (error) {
        await this.showRequestError(error);
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.loading = false;
      }
    },

    inspectionFormFieldChanged() {
      this.$emit("onChangeInspectionForm", true);
    },
  },

  mounted() {},

  watch: {
    inspectionForm(inspectionForm) {},
  },
};
</script>
